<app-main-layout
  [clickNext]="onClickNext"
  [clickBack]="onClickBack"
  [activateNextButton$]="nextButtonState.activateNext$"
  [activateNoTimeslotsWorkButton$]="nextButtonState.activateNoTimeslotsWorkButton$"
  [isBookingPage]="true"
  [bookAppointmentWithoutTimeslots]="noneWorksForMe"
  >
  <app-ppl-card [isPPL]="isPPL" text="Book within the next 72hrs to get 5% off your windows!"></app-ppl-card>
  <app-timer></app-timer>
  @if (showNotification && offer?.length) {
    <div class="offer-bar booking" [ngClass]="fadeClass">
      <div class="frame">
        <div class="icon">
          <img src="assets/icons/offer-icon.svg" alt="">
        </div>
        <div class="offer-bar-description">
          <strong class="offer-title">{{offer}}</strong>
        </div>
      </div>
    </div>
  }
  <div class="main-heading">
    <h2>Select a date and time for your 60 min consultation.</h2>
  </div>
  @if (isDataLoaded) {
    <form [formGroup]="scheduleForm" class="form">
      @if (calendarData[activeChunkNumber]) {
        <button
          class="control"
          aria-label="Previous"
          (click)="goBackward()"
          [disabled]="activeChunkNumber === 0"
          >
          <img src="/assets/icons/arrow-left.svg" alt="arrow-left" />
        </button>
      }
      <div class="calendar">
        <div class="days">
          @if (
            calendarData[activeChunkNumber] &&
            calendarData[activeChunkNumber]?.length
            ) {
            <div
              class="days-frame"
              >
              @for (day of calendarData[activeChunkNumber]; track day) {
                <div
                  class="day"
            [ngClass]="{
              active: day.date === activeDate,
              disabled: day.disabled,
              'first-chunk': activeChunkNumber === 0
            }"
                  (click)="setActiveDay(day)"
                  role="button"
                  >
                  <span class="title">{{ day.dayOfTheWeek }}</span>
                  <span class="date">
                    {{ day.formattedDate.day }}
                    <span class="month">{{ day.formattedDate.month }}</span>
                  </span>
                </div>
              }
            </div>
          }
        </div>
        @if (!noSlotsAvailableForThisDay) {
          <div class="time-slots">
            @for (day of activeSlots; track day) {
              <div class="period">
                @if (!noSlotsForSelectedPeriod(day)) {
                  <div class="period-frame">
                    <span class="title">{{ day.period }}</span>
                    <div class="slots">
                      @for (period of day.slots; track period) {
                        <div
                          class="slot"
                          [ngClass]="{ selected: (period.id+'_'+period.startTime) === selectedTime, hide: period.hide }"
                          >
                          <button (click)="selectTime(period)">{{ period.time }}</button>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (noSlotsAvailableForThisDay) {
          <div class="no-slots">
            There are no available appointments for {{formattedActiveDate}}. <br />
            Please select another day, to see available appointment slots.
          </div>
        }
      </div>
      @if (calendarData[activeChunkNumber]) {
        <button
          class="control next"
          aria-label="Next"
          (click)="goForward()"
          [disabled]="activeChunkNumber === this.numberOfChunks - 1"
          >
          <img src="/assets/icons/arrow-right-black.svg" alt="arrow-right" />
        </button>
      }
    </form>
  }
</app-main-layout>

<ng-template #noSlotsTemplate>
  <p class="no-appointment">*No appointment slots available for this day</p>
</ng-template>
